import CampaignPerformancePanel from './campaignPerformancePanel.container';

export default CampaignPerformancePanel;